import { useQuery } from "@tanstack/react-query";
import { ResourceRepositoryImpl } from "../../data/repository/resource_repository_impl";

export const useGetResourceById = (resourceId?: string) => {
    const repository = new ResourceRepositoryImpl();

    return useQuery({
        queryFn: () => repository.getResourceById(resourceId!),
        queryKey: ['resourceById', resourceId],
        enabled: !!resourceId,
    });
};